module.exports = function () {
    var $ = require('jquery');
    $('.panel-collapse').on('show.bs.collapse', function () {
        $(this).parents('.description-container').show('fast');
    });
    $('.panel-collapse').on('hide.bs.collapse', function () {
        $(this).parents('.description-container').hide('fast');
    });
};